export default "__VITE_ASSET__CW8SW$ch__"